import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import styled from 'styled-components';
import { ModalContentItemContext } from './context';
import { MODAL_BODY_VERTICAL_PADDING, MODAL_HORIZONTAL_PADDING } from './constants';
import { paddingVertical } from '../style/padding-vertical';
import { paddingHorizontal } from '../style/padding-horizontal';
const StyledModalBody = styled.div`
  flex-grow: 1;
  overflow: auto;
  ${paddingHorizontal(MODAL_HORIZONTAL_PADDING)}
  ${paddingVertical(MODAL_BODY_VERTICAL_PADDING)}
`;
const StyledWrapper = styled.div`
  ${({
  $hasSafeBottomPadding
}) => $hasSafeBottomPadding ? 'padding-bottom: env(safe-area-inset-bottom);' : ''}
`;
const ModalBody = /*#__PURE__*/React.forwardRef(({
  children,
  ...props
}, ref) => {
  const {
    last
  } = useContext(ModalContentItemContext);
  return /*#__PURE__*/React.createElement(StyledModalBody, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(StyledWrapper, {
    $hasSafeBottomPadding: last
  }, children));
});
export default ModalBody;